










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { HelperMethods } from '@/core/HelperMethods';
import { WoWRace, WoWClass, Player, GameRole } from '@/types/apiServerContract';

@Component
export default class OnlinePlayerGrid extends Vue {
	@Prop() players!: Player[];

	fields: any = [
	    { key: 'name', label: 'Name', sortable: true },
	    { key: 'race', label: 'Race', sortable: true },
	    { key: 'class', label: 'Class', sortable: true },
	    { key: 'level', label: 'Level', sortable: true },
	    { key: 'zone', label: 'Zone', sortable: true },
	    { key: 'rank', label: 'Rank', sortable: true }
	];

	async GetZoneName(zoneId: number) {
	    return await HelperMethods.GetZone(zoneId);
	}

	GetFaction(race: WoWRace) {
	    if (HelperMethods.IsHorde(race)) {
	        return 'horde_min.png';
	    }
	    return 'alliance_min.png';
	}

	GetClassColor(classId: WoWClass) {
	    return HelperMethods.GetClassColor(classId);
	}

	GetGameRankColor(rank: GameRole) {
	    return HelperMethods.GetGameRankColor(rank);
	}

	GetGameRankName(rank: GameRole) {
	    return HelperMethods.GetGameRankName(rank, true);
	}
}
